import Money from '../money';

interface DepositProps {
  amount: number;
  isBusinessContractHire?: boolean;
  isPersonalContractHire?: boolean;
}

const Deposit = ({
  amount,
  isBusinessContractHire = false,
  isPersonalContractHire = false,
}: DepositProps) => {
  return (
    <span className="ac-pricing__deposit">
      <Money amount={amount} />
      <span className="ac-pricing__suffix">
        {isBusinessContractHire || isPersonalContractHire
          ? 'Initial rental'
          : 'Deposit'}
      </span>
    </span>
  );
};

export default Deposit;
